import { Empty, Select, Grid, List } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStaff } from "../../redux/actions/user.actions";
import { setLoading } from "../../redux/actions/app.actions";

import { getAllStaff } from "../../services/staffs.services";
import moment from "moment-timezone";
import { findWindows } from "windows-iana";
import EventDrawer from "components/EventDrawer/EventDrawer";
import {
  assignNursePractitioner,
  getChartsByStatus,
} from "services/charts.services";
import { openChartURL } from "utils/common";

import ChartCard from "./components/ChartCard";

const { Option } = Select;
const { useBreakpoint } = Grid;

const Charts = ({ dates, sorting, npFilter, searchText, page, setPage }) => {
  const dispatch = useDispatch();
  const screens = useBreakpoint();

  const abortConRef = React.useRef();

  const [modalVisible, setModalVisible] = useState(false);

  const allStaffs = useSelector((state) => state.user.wholeStaff).filter(
    (staff) => {
      if (
        staff.roleName === "Nurse Practitioner" ||
        staff.roleName === "Physician"
      )
        return true;
      return false;
    }
  );
  const allCharts = useSelector((state) => state.charts.allCharts);
  const currentStaff = useSelector((state) => state.user.currentUser);
  const currentOrder = useSelector((state) => state.orders.currentOrder);

  // const getAllPractitioners = async () => {
  //   dispatch(setLoading(true));
  //   await dispatch(getAllStaff(null, []));
  //   dispatch(setLoading(false));
  // };

  useEffect(() => {
    if (currentStaff?.staffId) getData();
  }, [dates, currentStaff, npFilter]);

  const getData = async () => {
    const windowsTimezone = findWindows(moment.tz.guess());
    const roleName = currentStaff.roleName?.trim?.() || "";
    dispatch(setLoading(true));

    if (abortConRef.current) abortConRef.current.abort();
    abortConRef.current = new AbortController();

    await dispatch(
      getChartsByStatus(
        "Pending",
        {
          FromServiceDate: dates?.[0] ? dates[0].format("YYYY-MM-DD") : null,
          toServiceDate: dates?.[1] ? dates[1].format("YYYY-MM-DD") : null,
          ...npFilter,
          // serviceDate: moment.utc(dates).local().format("YYYY-MM-DD"),
          // staffId:
          //   currentStaff &&
          //   !(
          //     roleName === "Admin" ||
          //     roleName === "Nurse Practitioner" ||
          //     roleName === "Nurse Lead"
          //   )
          //     ? currentStaff.staffId
          //     : null,

          // timezone: windowsTimezone?.[0],
        },
        abortConRef?.current?.signal
      )
    );
    // await dispatch(getAllStaff(currentStaff?.facilityId, ['Nurse Practitioner']))
    dispatch(setLoading(false));
  };

  useEffect(() => {
    if (currentStaff) {
      // getData();
      // getAllPractitioners();
    }
  }, [currentStaff]); //eslint-disable-line

  const isSmallDevice = !screens.md;
  const currentStaffRoleName = currentStaff?.roleName?.trim?.() || "";

  const data = React.useMemo(() => {
    let data = [...allCharts];

    if (searchText) {
      data = data.filter((chart) => {
        const searchLower = searchText.toLowerCase();

        const clinicianMatch = chart?.staffName?.toLowerCase?.().includes(searchLower);
        const npPhysician = allStaffs?.find?.(staff => staff.staffId === chart?.staffPhysicianId)
        const npPhysicianName = npPhysician?.firstName + " " + npPhysician?.lastName

        const npPhysicianMatch = npPhysicianName?.toLowerCase?.().includes(searchLower)

        return chart.guestName?.toLowerCase?.().includes(searchLower) || clinicianMatch || npPhysicianMatch;
      });
    }

    if (sorting === "pending") {
      // data = data.sort((a, b) => {
      //   // Charts with no staffSignature come first
      //   if (!a.staffSignature && b.staffSignature) return -1;
      //   if (a.staffSignature && !b.staffSignature) return 1;
      //   return 0;
      // });
      data = data.sort((a, b) => {
        // Calculate a score for each chart: higher means more "signed off"
        const score = (chart) => {
          let s = 0;
          if (chart.staffSignature) s += 1;
          if (chart.physicianSignature) s += 1;
          return s;
        };
        return score(a) - score(b);
      });
    } else if (sorting === "signedOff") {
      data = data.sort((a, b) => {
        // Calculate a score for each chart: higher means more "signed off"
        const score = (chart) => {
          let s = 0;
          if (chart.staffSignature) s += 1;
          if (chart.physicianSignature) s += 1;
          return s;
        };
        return score(b) - score(a);
      });
    } else if (sorting === "newestToOldest") {
      data = data.sort(
        (a, b) => moment(b.serviceDate) - moment(a.serviceDate)
      );
    } else if (sorting === "oldestToNewest") {
      data = data.sort(
        (a, b) => moment(a.serviceDate) - moment(b.serviceDate)
      );
    } else if (sorting === "inClinic") {
      data = data.filter((chart) => chart.operationType.name === "Clinic");
    } else if (sorting === "mobile") {
      data = data.filter((chart) => chart.operationType.name === "Mobile");
    } else if (sorting === "all") {
      data = [...allCharts];
    }

    return data;

  }, [allCharts, currentStaff, allStaffs, sorting, searchText])

  return (
    <div>
      <EventDrawer
        order={currentOrder}
        setShowEventDrawer={setModalVisible}
        visible={modalVisible}
        onClose={() => {
          setModalVisible(false);
          dispatch(setCurrentStaff(null));
        }}
        getData={getData}
      />

      <div
        style={{
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: 30,
        }}
      >
        <List
          style={{ width: '100%' }}
          dataSource={data}
          size="large"
          renderItem={(chart) => {
            return <ChartCard
              key={chart.chartId}
              chart={chart}
              currentStaffRoleName={currentStaffRoleName}
              onClick={() => {
                openChartURL(chart.orderId, chart.orderLineItemId, {
                  isLegacy: chart.isLegacy,
                  productName: chart.legacyChartName,
                });
              }}
              onNPChange={async (val) => {
                try {
                  dispatch(setLoading(true));
                  await assignNursePractitioner(val, chart.chartId);
                  getData();
                } catch (error) {
                  console.log(error);
                }
              }}
              filteredStaff={allStaffs}
            />
          }}

          pagination={{
            current: page.page,
            pageSize: page.pagesize,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: [10, 25, 50, 100, 250],
            position: "bottom",
            style: { margin: "16px 0px" },
            onChange: (pageNum, pageSize) => {
              setPage({ page: pageNum, pagesize: pageSize });
            }
          }}
          locale={{ emptyText: <Empty description="No Charts" /> }}
        />
      </div>
    </div>
  );
};

export default Charts;
